export const APPLICABLE_MODEL_YEARS: readonly number[] = [2022, 2023, 2024, 2025, 2026, 2027];

/** One carline row of the applicable models matrix. */
export type ApplicableModel = {
    /** Carline display name. */
    carline: string;
    /** Whether the carline carries the DST-010 note. */
    hasNote: boolean;
    /** Model years that support the SSM5 diagnostic. */
    modelYears: readonly number[];
};

export const APPLICABLE_MODELS: readonly ApplicableModel[] = [
    { carline: 'Outback / Legacy', hasNote: false, modelYears: [2023, 2024, 2025, 2026, 2027] },
    { carline: 'Crosstrek / Impreza', hasNote: true, modelYears: [2024, 2025, 2026, 2027] },
    { carline: 'Forester', hasNote: false, modelYears: [2025, 2026, 2027] },
    { carline: 'WRX', hasNote: false, modelYears: [2023, 2024, 2025, 2026, 2027] },
    { carline: 'Ascent / Evolis', hasNote: false, modelYears: [2023, 2024, 2025, 2026, 2027] },
    { carline: 'BRZ', hasNote: false, modelYears: [2022, 2023, 2024, 2025, 2026, 2027] },
];

/** The width of the modals that ask the technician for a decision. */
export const DECISION_MODAL_WIDTH = 528;

/**
 * How long a connect attempt is expected to take at most; one that runs this long is flagged to the
 * technician as taking longer than expected.
 */
export const EXPECTED_CONNECT_DURATION_MS = 30000;
